<footer class="app-footer">
    <p>&copy; 2024 Transend Financial. All rights reserved.</p>
  </footer>
  